export const tallewFlatbread = {
  id: "tallewFlatbread",
  link: "/#/recipes/recipes/tallewFlatbread",
  name: "Tallew Flatbread",
  cuisine: "General",
  summary: "Thin flatbread, good for curries and sauce-covered dishes.",
  inspiration: "Rice Roti",
  quantity: "6",
  time: "30 minutes",
  notes:
    "While it's easiest to just buy corn tortillas and use those for Rosharan flatbread, making your own rice-based flatbread is a good way to mix things up. On Roshar, they do make flatbread from both lavis and tallew.",
  quotes:
    "...like stacked sacks of tallew, stored for the winter season. I would make flatbread of them soon. (The Way of Kings, ch 58)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/tallew-flatbread-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "water",
          display: "1 cup water"
        },
        {
          item: "salt",
          display: "1/4 tsp salt"
        },
        {
          item: "rice",
          display: "1 cup rice flour"
        }
      ]
    }
  ],
  steps: [
    "Bring water and salt to a boil in a saucepan. Add rice flour all at once and mix until combined.",
    "Remove from heat, cover, and let rest 10 minutes.",
    "Lightly cover your hands in oil, then knead the dough into a ball. Separate into 6 pieces and roll into balls.",
    "Heat a nonstick electric griddle to 375 degrees Fahrenheit. One at a time, place a dough ball between 2 pieces of parchment paper and roll until very thin.",
    "Peel the dough off the paper and place on the griddle. Cook until surface is firm and not tacky, and it almost starts to brown in spots, flipping once. It should puff after the first flip. Serve with curry or other Rosharan dishes."
  ]
}
